import { render, staticRenderFns } from "./Exportacao.vue?vue&type=template&id=2ca0898d&scoped=true&"
import script from "./Exportacao.vue?vue&type=script&lang=js&"
export * from "./Exportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca0898d",
  null
  
)

export default component.exports